import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import useApiRequest from "../../utils/hooks/useApiRequest";
import { GET_TIME_FROM_BIRTHDAY } from "../../app/api/apiRoutes";
import useFacility from "../../utils/hooks/useFacility";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";

interface IProps {
  value: string;
  label: string;
  name: string;
  setTime: (value: string) => void;
  dateFrom: string;
  dateTo: string;
  assortIds: string;
}

const InputTimeForBirthDay: React.FC<IProps> = ({
  value,
  label,
  name,
  setTime,
  dateTo,
  dateFrom,
  assortIds,
}: IProps) => {
  const [open, setOpen] = useState(false);
  const [timeList, setTimeList] = useState([]);
  const { get } = useApiRequest();
  const facility = useFacility();
  const { t } = useTranslation();

  const getTime = async () => {
    const { result, isError } = await get(GET_TIME_FROM_BIRTHDAY(facility, dateFrom, dateTo, assortIds));
    if (!isError) {
      const searchDate = result.find((item: any) => item.date === dateFrom);
      setTimeList(searchDate ? searchDate.hours : []);
    }
  };

  const onSelectTime = (value: string) => {
    setTime(value);
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      getTime();
    }
  }, [open]);

  return (
    <React.Fragment>
      <div className={"form-input-date"}>
        <label htmlFor={name}>{label}</label>

        {value ? (
          <button className="button medium padding-medium button-fill-background-second" onClick={() => setOpen(true)}>
            {value}
          </button>
        ) : (
          <button className="button medium padding-medium button-fill-second" onClick={() => setOpen(true)}>
            {t("wybierz_godzine")}
          </button>
        )}
      </div>

      {open && (
        <Modal
          isOpen={open}
          onRequestClose={() => setOpen(false)}
          contentLabel="modal"
          className="modal-calendar"
          style={{ content: { minWidth: "40vmin", maxWidth: "60vmin" } }}
        >
          <React.Fragment>
            <h3>{t("wybierz_godzine_wejscia")}:</h3>
            <div className="line-horizontal"></div>
            <Grid container spacing={2}>
              {timeList.map((item, index) => (
                <Grid key={index} item xs={2}>
                  <button
                    className={"button medium padding-medium button-outline-gray move-up"}
                    onClick={() => onSelectTime(item)}
                  >
                    {item}
                  </button>
                </Grid>
              ))}
            </Grid>
          </React.Fragment>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default InputTimeForBirthDay;
